import Select from '@zenbusiness/zui/Select';
import { superstyled } from '@zenbusiness/zui/styles';

export const YearSelect = superstyled({
  tag: Select,
  name: 'OrderTemplate',
  slot: 'YearSelect',
  styles: { width: '200px' },
});
